const swan700List = [
    {
        label: 'Swan 700',
        value: '天鹅Swan 700',
        letter: 'A',
    },
    {
        label: 'Swan 710E',
        value: '天鹅Swan 710E',
        letter: 'A',
    },
    {
        label: 'Swan 720E',
        value: '天鹅Swan 720E',
        letter: 'A',
    },
    {
        label: 'Swan 710S',
        value: '天鹅Swan 710S',
        letter: 'A',
    },
    {
        label: 'Swan 720S',
        value: '天鹅Swan 720S',
        letter: 'A',
    },
    {
        label: 'Swan 750M',
        value: '天鹅Swan 750M',
        letter: 'A',
    },
    {
        label: 'Swan 760M',
        value: '天鹅Swan 760M',
        letter: 'A',
    },
];

const swan700PList = [
    {
        label: 'Swan 700P',
        value: '天鹅Swan 700P',
        letter: 'B',
    },
    {
        label: 'Swan 730E',
        value: '天鹅Swan 730E',
        letter: 'B',
    },
    {
        label: 'Swan 760E',
        value: '天鹅Swan 760E',
        letter: 'B',
    },
    {
        label: 'Swan 730S',
        value: '天鹅Swan 730S',
        letter: 'B',
    },
    {
        label: 'Swan 750S',
        value: '天鹅Swan 750S',
        letter: 'B',
    },
    {
        label: 'Swan 760S',
        value: '天鹅Swan 760S',
        letter: 'B',
    },
    {
        label: 'Swan 770M',
        value: '天鹅Swan 770M',
        letter: 'B',
    },
    {
        label: 'Swan 780M',
        value: '天鹅Swan 780M',
        letter: 'B',
    },
    {
        label: 'Swan 790M',
        value: '天鹅Swan 790M',
        letter: 'B',
    },
];

const swan600List = [
    {
        label: 'Swan 600',
        value: '天鹅Swan 600',
        letter: 'A',
    },
    {
        label: 'Swan 610E',
        value: '天鹅Swan 610E',
        letter: 'A',
    },
    {
        label: 'Swan 620E',
        value: '天鹅Swan 620E',
        letter: 'A',
    },
    {
        label: 'Swan 610S',
        value: '天鹅Swan 610S',
        letter: 'A',
    },
    {
        label: 'Swan 620S',
        value: '天鹅Swan 620S',
        letter: 'A',
    },
    {
        label: 'Swan 650M',
        value: '天鹅Swan 650M',
        letter: 'A',
    },
    {
        label: 'Swan 660M',
        value: '天鹅Swan 660M',
        letter: 'A',
    },
];

const swan600PList = [
    {
        label: 'Swan 600P',
        value: '天鹅Swan 600P',
        letter: 'B',
    },
    {
        label: 'Swan 630E',
        value: '天鹅Swan 630E',
        letter: 'B',
    },
    {
        label: 'Swan 660E',
        value: '天鹅Swan 660E',
        letter: 'B',
    },
    {
        label: 'Swan 630S',
        value: '天鹅Swan 630S',
        letter: 'B',
    },
    {
        label: 'Swan 650S',
        value: '天鹅Swan 650S',
        letter: 'B',
    },
    {
        label: 'Swan 660S',
        value: '天鹅Swan 660S',
        letter: 'B',
    },
    {
        label: 'Swan 670M',
        value: '天鹅Swan 670M',
        letter: 'B',
    },
    {
        label: 'Swan 680M',
        value: '天鹅Swan 680M',
        letter: 'B',
    },
    {
        label: 'Swan 690M',
        value: '天鹅Swan 690M',
        letter: 'B',
    },
]

// 天龙800系列
const TL800list = [
    // B系列
    {
        label: '天龙890M',
        value: '天龙 TL890M',
        letter: 'B',
    },
    {
        label: '天龙880M',
        value: '天龙 TL880M',
        letter: 'B',
    },
    {
        label: '天龙870M',
        value: '天龙 TL870M',
        letter: 'B',
    },
    {
        label: '天龙860S',
        value: '天龙 TL860S',
        letter: 'B',
    },
    {
        label: '天龙850S',
        value: '天龙 TL850S',
        letter: 'B',
    },
    {
        label: '天龙830S',
        value: '天龙 TL830S',
        letter: 'B',
    },
    {
        label: '天龙860E',
        value: '天龙 TL860E',
        letter: 'B',
    },
    {
        label: '天龙830E',
        value: '天龙 TL830E',
        letter: 'B',
    },
    // A系列
    {
        label: '天龙860M',
        value: '天龙 TL860M',
        letter: 'A',
    },
    {
        label: '天龙850M',
        value: '天龙 TL850M',
        letter: 'A',
    },
    {
        label: '天龙820S',
        value: '天龙 TL820S',
        letter: 'A',
    },
    {
        label: '天龙810S',
        value: '天龙 TL810S',
        letter: 'A',
    },
    {
        label: '天龙820E',
        value: '天龙 TL820E',
        letter: 'A',
    },
    {
        label: '天龙810E',
        value: '天龙 TL810E',
        letter: 'A',
    },
];

const TD900List = [
    // B系列
    {
        label: '天龙990M',
        value: '天龙 TD990M',
        letter: 'B',
    },
    {
        label: '天龙980M',
        value: '天龙 TD980M',
        letter: 'B',
    },
    {
        label: '天龙970M',
        value: '天龙 TD970M',
        letter: 'B',
    },
    {
        label: '天龙960S',
        value: '天龙 TD960S',
        letter: 'B',
    },
    {
        label: '天龙950S',
        value: '天龙 TD950S',
        letter: 'B',
    },
    {
        label: '天龙930S',
        value: '天龙 TD930S',
        letter: 'B',
    },
    {
        label: '天龙960E',
        value: '天龙 TD960E',
        letter: 'B',
    },
    {
        label: '天龙930E',
        value: '天龙 TD930E',
        letter: 'B',
    },
    // A系列
    {
        label: '天龙960M',
        value: '天龙 TD960M',
        letter: 'A',
    },
    {
        label: '天龙950M',
        value: '天龙 TD950M',
        letter: 'A',
    },
    {
        label: '天龙920S',
        value: '天龙 TD920S',
        letter: 'A',
    },
    {
        label: '天龙910S',
        value: '天龙 TD910S',
        letter: 'A',
    },
    {
        label: '天龙920E',
        value: '天龙 TD920E',
        letter: 'A',
    },
    {
        label: '天龙910E',
        value: '天龙 TD910E',
        letter: 'A',
    },
];

// 天鹅
const SWANList = [
    {
        label: "天鹅600",
        value: '天鹅Swan 600',
        letter: "A",
    },
    {
        label: "天鹅600P",
        value: '天鹅Swan 600P',
        letter: "B",
    },
    {
        label: "天鹅600E",
        value: '天鹅Swan 600E',
        letter: "B",
    },
    {
        label: "天鹅600S",
        value: '天鹅Swan 600S',
        letter: "A",
    },
    {
        label: "天鹅600M",
        value: '天鹅Swan 600M',
        letter: "A",
    },
    {
        label: "天鹅600H",
        value: '天鹅Swan 600H',
        letter: "B",
    },
    {
        label: "天鹅600L",
        value: '天鹅Swan 600L',
        letter: "A",
    },
    {
        label: "天鹅600T",
        value: '天鹅Swan 600T',
        letter: "B",
    },
];

const YAGList = [
    {
        label: "BP-E06",
        value: 'BP-E06',
        letter: "",
    },
]

const EYESPAList = [
    {
        label: "EYE",
        value: 'EYE',
        letter: "",
    },
]

// 350S/330S/320S/310S
// 350E/330E/320E/310E
// 390M/380M/370M/360M
// 天鸽
const COLUMBAList = [
    // {
    //     label: "筛查箱310",
    //     value: 'SCX310',
    //     letter: "B",
    // },
    // {
    //     label: "筛查箱310S",
    //     value: 'SCX310S',
    //     letter: "A",
    // },
    {
        label: "天鸽300",
        value: '天鸽Columba300',
        letter: "A",
    },
    {
        label: "天鸽300S",
        value: '天鸽Columba300S',
        letter: "A",
    },
    {
        label: '天鸽310S',
        value: '天鸽Columba310S',
        letter: "A",
    },
    {
        label: '天鸽310E',
        value: '天鸽Columba310E',
        letter: "A",
    },
    {
        label: '天鸽320S',
        value: '天鸽Columba320S',
        letter: "A",
    },
    {
        label: '天鸽320E',
        value: '天鸽Columba320E',
        letter: "A",
    },
    {
        label: '天鸽330S',
        value: '天鸽Columba330S',
        letter: "A",
    },
    {
        label: '天鸽330E',
        value: '天鸽Columba330E',
        letter: "A",
    },
    {
        label: '天鸽350S',
        value: '天鸽Columba350S',
        letter: "A",
    },
    {
        label: '天鸽350E',
        value: '天鸽Columba350E',
        letter: "A",
    },
    {
        label: '天鸽360M',
        value: '天鸽Columba360M',
        letter: "A",
    },
    {
        label: '天鸽370M',
        value: '天鸽Columba370M',
        letter: "A",
    },
    {
        label: '天鸽380M',
        value: '天鸽Columba380M',
        letter: "A",
    },
    {
        label: '天鸽390M',
        value: '天鸽Columba390M',
        letter: "A",
    },
];



const TH700LIST = [
    {
        label: "天鹤710E",
        value: '天鹤 TH710E',
        letter: "A",
    },
    {
        label: "天鹤720E",
        value: '天鹤 TH720E',
        letter: "A",
    },
    {
        label: "天鹤730E",
        value: '天鹤 TH730E',
        letter: "A",
    },
    {
        label: "天鹤760E",
        value: '天鹤 TH760E',
        letter: "A",
    },
    {
        label: "天鹤710S",
        value: '天鹤 TH710S',
        letter: "A",
    },
    {
        label: "天鹤720S",
        value: '天鹤 TH720S',
        letter: "A",
    },
    {
        label: "天鹤730S",
        value: '天鹤 TH730S',
        letter: "A",
    },
    {
        label: "天鹤750S",
        value: '天鹤 TH750S',
        letter: "A",
    },
    {
        label: "天鹤760S",
        value: '天鹤 TH760S',
        letter: "A",
    },
    {
        label: "天鹤750M",
        value: '天鹤 TH750M',
        letter: "A",
    },
    {
        label: "天鹤760M",
        value: '天鹤 TH760M',
        letter: "A",
    },
    {
        label: "天鹤770M",
        value: '天鹤 TH770M',
        letter: "A",
    },
    {
        label: "天鹤780M",
        value: '天鹤 TH780M',
        letter: "A",
    },
    {
        label: "天鹤790M",
        value: '天鹤 TH790M',
        letter: "A",
    },
]



export const machineTypeOption = [
    {
        label: "天鸽",
        value: "天鸽",
        type: "SCX",
        children: COLUMBAList,
    },
    {
        label: '天鹅',
        value: '天鹅',
        type: "天鹅Swan ",
        children: [...swan600List, ...swan600PList, ...swan700List, ...swan700PList],
    }, {
        label: "星豚",
        value: "星豚",
        type: "星豚Starton ",
        children: [
            {
                label: "星豚Starton 220",
                value: "星豚Starton 220",
                letter: "A",
            },
            {
                label: "星豚Starton 230",
                value: "星豚Starton 230",
                letter: "A",
            },
            {
                label: "星豚Starton 260",
                value: '星豚Starton 260',
                letter: "A",
            },
            {
                label: "星豚Starton 270",
                value: "星豚Starton 270",
                letter: "A",
            },
        ],
    }, {
        label: "蓝鲸",
        value: "蓝鲸",
        type: "LW",
        children: [
            {
                label: "蓝鲸110",
                value: '蓝鲸LanW 110',
                letter: "A",
            },
            {
                label: "蓝鲸120",
                value: '蓝鲸LanW 120',
                letter: "A",
            },
            {
                label: "蓝鲸130",
                value: '蓝鲸LanW 130',
                letter: "A",
            },
        ],
    }, {
        label: "天鹤",
        value: "天鹤",
        type: "TH",
        children: [
            ...TH700LIST
        ]
    },
    {
        label: '天龙',
        value: '天龙',
        type: 'TL',
        children: [
            ...TL800list,
            ...TD900List,
        ]
    }
];


